export const getFormDataTableSelector = () => '.form-data-table';

export const getFormDataTableRowSelector = () =>
  '.form-data-table th, .form-data-table td';
